import { cloneDeep } from "lodash";
import dayjs from '../../dayjs';

export class Entitlement {
    constructor(data) {
        this.effectiveStartDate = null;
        this.effectiveEndDate = null;
        this.title = null;
        this.reason = null;
        this.payRate = null;

        this.entitlements = {
            permanent: {
                workWeek: null,
                perHour: null,
                timeAndHalf: null,
                doubleTime: null,
                doubleTimeAndHalf: null,
            },
            casual: {
                workWeek: null,
                perHour: null,
                timeAndHalf: null,
                doubleTime: null,
                doubleTimeAndHalf: null,
            },
            allowance: {
                workWeek: null,
                perHour: null,
                timeAndHalf: null,
                doubleTime: null,
                doubleTimeAndHalf: null,
            }
        }
        Object.assign(this, data);
        // Robust date handling
        if (typeof this.effectiveStartDate === 'string') {
            this.effectiveStartDate = dayjs(this.effectiveStartDate);
        }
        if (typeof this.effectiveEndDate === 'string') {
            this.effectiveEndDate = dayjs(this.effectiveEndDate);
        }
        // Robustly handle policies validity
        if (Array.isArray(this.policies)) {
            this.policies = this.policies.map(policy => {
                if (Array.isArray(policy.validity)) {
                    return {
                        ...policy,
                        validity: policy.validity.map(v => (typeof v === 'string' ? dayjs(v) : v)),
                    };
                }
                return policy;
            });
        }
    }

    toJson() {
        return {
            ...this,
            effectiveStartDate: this.effectiveStartDate ? this.effectiveStartDate.format('YYYY-MM-DD') : null,
            effectiveEndDate: this.effectiveEndDate ? this.effectiveEndDate.format('YYYY-MM-DD') : null,
            policies: Array.isArray(this.policies)
                ? this.policies.map(policy => ({
                    ...policy,
                    validity: Array.isArray(policy.validity)
                        ? policy.validity.map(v => v && typeof v.format === 'function' ? v.format('YYYY-MM-DD') : v)
                        : policy.validity,
                }))
                : this.policies,
        };
    }

    static fromJson(data) {
        return new Entitlement(data);
    }

    static clone(entitlement) {
        return new Entitlement(cloneDeep(entitlement));
    }
}